<div class="note">
    <h4><i class="fas fa-lightbulb-on"></i> Tipps</h4>
    <p>
        <i class="fas fa-edit"></i><span>Erstellen Sie Schritt-für-Schritt Tafelbilder, mit oder ohne gesprochener Audiospur.</span>
    </p>
    <p>
        <i class="fas fa-link"></i><span>Verlinken Sie Ihre Tafelbild-Aufnahmen mit Symbolen auf den Buchseiten</span>
    </p>
</div>
